var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-border overflow-x-auto overflow-hidden relative"},[_c('div',{directives:[{name:"dragscroll",rawName:"v-dragscroll.x",modifiers:{"x":true}}],staticClass:"whitespace-nowrap overflow-x-auto overflow-y-hidden pb-6 max-w-full"},[_c('div',{staticClass:"cursor-grab"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }